import useError from 'lib/hooks/useError';
import useSavedPaymentMethods from 'lib/hooks/useSavedPaymentMethods';

import { usePaymentContext } from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';
import Modal from 'components/shared/Modal/Modal';
import Typography from 'components/shared/Typography/Typography';

import ErrorPaymentModal from '../../ErrorModal';

import PayWithCardContent from './PayWithCardContent';

const PayWithCardModal = ({ isOpen, handleClose, patientId }) => {
  const { terminal, values } = usePaymentContext();
  const { error, setErrorMessage } = useError();

  const {
    data: cards,
    active,
    setActive,
    scrollRef,
    isFetchingNextPage
  } = useSavedPaymentMethods({
    patientId,
    terminalId: terminal?.id,
    type: 'card'
  });

  const closeModal = () => {
    handleClose();
    setActive('credit-card');
    setErrorMessage(null);
  };

  if (error)
    return (
      <ErrorPaymentModal
        message={error}
        onClearError={() => setErrorMessage(null)}
        onClose={closeModal}
      />
    );

  return (
    <Modal
      isOpen={isOpen}
      handleClose={closeModal}
      isCentered
      customTitle={
        <Typography variant="p" color="neutral-800" weight="medium" size="small">
          {values?.recurringPayment ? 'Create payment plan' : 'Pay online'}
        </Typography>
      }
      footer={null}
      isFooter={false}>
      <PayWithCardContent
        cards={cards}
        active={active}
        setActive={setActive}
        scrollRef={scrollRef}
        isFetchingNextPage={isFetchingNextPage}
        values={values}
        setErrorMessage={setErrorMessage}
        buttonText={values?.recurringPayment ? 'Create payment plan' : undefined}
      />
    </Modal>
  );
};

export default PayWithCardModal;
